import React from "react";
import Menu from "@material-ui/core/Menu";
import Box from "@material-ui/core/Box";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";

import "./menu.scss";

const StyledMenu = (props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
);

export default function CustomizedMenus() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Box
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        onMouseOver={handleClick}
      >
        Werkzeuge
      </Box>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onMouseLeave={handleClose}
      >
        <MenuItem disabled>
          <ListItemText primary="Übersicht" />
        </MenuItem>
        <MenuItem>
          <a href="https://dialog.napkon.de/" className="menuLink">
            Forum
          </a>
        </MenuItem>
        <MenuItem>
          <a href="https://dialog.napkon.de/g">Gruppen</a>
        </MenuItem>
        <MenuItem>
          <a href="https://dialog.napkon.de/g?type=my">Meine Gruppen</a>
        </MenuItem>
        <MenuItem>
          <a href="https://dialog.napkon.de/u">Alle User</a>
        </MenuItem>
        <MenuItem>
          <a href="https://testcloud.idcohorts.net/apps/files/">Dateiablage</a>
        </MenuItem>
        <MenuItem>
          <a href="https://cloud.napkon.de/apps/calendar/">Kalender</a>
        </MenuItem>
        <MenuItem>
          <a href="https://dialog.napkon.de/c/handbuch">Handbuch</a>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
